package com.rainbowclubs.rainbow.data.repositories

import com.rainbowclubs.rainbow.data.responses.SelectClubResponse
import com.rainbowclubs.rainbow.domain.repositories.SelectClubRepository
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.http.isSuccess

class SelectClubRepositoryImpl(
    private val httpClient: HttpClient,
) : SelectClubRepository {
    override suspend fun getSelectedClubs(): Result<SelectClubResponse> {
        return try {
            val response = httpClient.get("/select_club")
            if (response.status.isSuccess()) {
                Result.success(response.body())
            } else {
                Result.failure(Exception(response.status.description))
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

}
